import { useState, useEffect } from "react";
import "./BatchDetailDialog.css";
import AdminDashboardService from "../../services/AdminDashboard.service";

const BatchDetailDialog = ({ isOpen, onClose, campaign, start_date, end_date }) => {

  const [loading, setLoading] = useState(false);
  const [batches, setBatches] = useState([]);

  const fetchBatchData = async () => {
    if (!campaign) return;

    try {
      setLoading(true);

      const payload = {
        campaign_id: campaign.campaign_id,
        start_date,
        end_date,
      };

      const res = await AdminDashboardService.getBatches(payload);
      setBatches(res?.data?.data || []);
    } catch (err) {
      console.error("Error loading batch data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchBatchData();
    }
  }, [campaign, start_date, end_date, isOpen]);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen || !campaign) return null;

  return (
    <div className="batch-dialog-overlay" onClick={handleBackdropClick}>
      <div className="batch-dialog-container">

        {/* Header */}
        <div className="batch-dialog-header">
          <div className="batch-dialog-title-section">
            <h2>{campaign?.campaign_name}</h2>
            <p className="batch-dialog-subtitle">Campaign Batch Details</p>
          </div>
          <button className="batch-dialog-close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        {/* Campaign Stats */}
        <div className="batch-dialog-stats-row">
          <Stat label="Total allocation" value={campaign?.allocation} />
          <Stat label="Calls made" value={campaign?.attempted_calls} />
          <Stat label="Connected" value={campaign?.connected_calls} />
          <Stat label="Positive" value={campaign?.positive_calls} />
          <Stat label="Collected" value={campaign?.collected} />
        </div>

        {/* Batches Section */}
        <div className="batch-dialog-batches-section">
          <h3 className="batch-dialog-batches-title">BATCHES</h3>

          {loading ? (
            <p>Loading batches...</p>
          ) : (
            <div className="batch-dialog-batches-grid">
              {batches?.map((batch) => (
                <div key={batch.batch_id} className="batch-dialog-batch-card">

                  {/* Header */}
                  <div className="batch-dialog-batch-header">
                    <div className="batch-dialog-batch-id">{batch.batch_id}</div>
                    <div className="batch-dialog-batch-name">{batch.batch_name}</div>
                    <div className="batch-dialog-batch-date">
                      {batch.start_date} - {batch.end_date}
                    </div>
                  </div>

                  {/* Stats */}
                  <div className="batch-dialog-batch-stats">
                    <Stat label="Allocated" value={batch.allocation} />
                    <Stat label="Calls" value={batch.attempted_calls} />
                    <Stat label="Connected" value={batch.connected_calls} />
                    <Stat label="Positive" value={batch.positive_calls} />
                    <Stat label="Collected" value={batch.collected} />
                  </div>

                  {/* Progress */}
                  <div className="batch-dialog-batch-progress">
                    <Progress label="connected" value={batch.connect_percentage} />
                    <Progress label="conversion" value={batch.conversion_percentage} />
                  </div>

                </div>
              ))}
            </div>
          )}
        </div>

      </div>
    </div>
  );
};


const Stat = ({ label, value }) => (
  <div className="batch-dialog-stat-card">
    <div className="batch-dialog-stat-label">{label}</div>
    <div className="batch-dialog-stat-value">
      {((value || 0) / 1000).toFixed(1)}k
    </div>
  </div>
);

const Progress = ({ label, value }) => (
  <div className="batch-dialog-progress-item">
    <div className="batch-dialog-progress-bar">
      <div
        className={`batch-dialog-progress-fill ${label}`}
        style={{ width: `${value || 0}%` }}
      />
    </div>
    <span className="batch-dialog-progress-text">
      {value || 0}% {label}
    </span>
  </div>
);

export default BatchDetailDialog;